import axios from "axios";

export default {
    FLICKR_API_KEY: 'a3b6996379f3b7a9f12438c7cd691387',
    FLICKR_API_URL: 'https://api.flickr.com/services/rest/?method=',
    FLICKR_USER_ID: '67767507@N05',
    PHOTOSET_KEY: '72157642504839734',

    getBannerPhotoset: function () {
        const apiUrl = this.FLICKR_API_URL + 'flickr.photosets.getPhotos&api_key=' + this.FLICKR_API_KEY + '&photoset_id=' + this.PHOTOSET_KEY + '&extras=description%2C+machine_tags%2C+url_sq%2C+url_t%2C+url_s%2C+url_q%2C+url_m%2C+url_n%2C+url_o%2C+url_c%2C+url_l%2C+url_z&format=json&nojsoncallback=1'
        return axios.get(apiUrl).then(result => {
            return result.data.photoset.photo
        })
    },

    getBuildingPhotoset: function () {
        const apiUrl = `${this.FLICKR_API_URL}flickr.photos.search&api_key=${this.FLICKR_API_KEY}&user_id=${this.FLICKR_USER_ID}&tags=:building&extras=description%2C+machine_tags%2C+url_sq%2C+url_t%2C+url_s%2C+url_q%2C+url_m%2C+url_n%2C+url_o%2C+url_c%2C+url_l%2C+url_z&format=json&nojsoncallback=1`
        return axios.get(apiUrl).then(result => {
            return result.data.photos.photo
        })
    },

    getPhotos: function () {
        return Promise.all([
            this.getBannerPhotoset(),
            this.getBuildingPhotoset()
        ]).then(results => {
            let items = []
            results.forEach(photos => {
                items = items.concat(...photos)
            })

            let currentIndex = items.length, randomIndex;

            // While there remain elements to shuffle...
            while (currentIndex != 0) {

                // Pick a remaining element...
                randomIndex = Math.floor(Math.random() * currentIndex);
                currentIndex--;

                // And swap it with the current element.
                [items[currentIndex], items[randomIndex]] = [
                    items[randomIndex], items[currentIndex]];
            }

            return items
        })
    },

    getFacilityPhotos: function (facilityNo) {
        const apiUrl = `${this.FLICKR_API_URL}flickr.photos.search&api_key=${this.FLICKR_API_KEY}&user_id=${this.FLICKR_USER_ID}&machine_tags=building:building=${facilityNo}&extras=description%2C+machine_tags%2C+url_sq%2C+url_t%2C+url_s%2C+url_q%2C+url_m%2C+url_n%2C+url_o%2C+url_c%2C+url_l%2C+url_z&format=json&nojsoncallback=1`
        return axios.get(apiUrl).then(result => {
            return result.data.photos.photo
        })
    },

}
